import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { GetPointOfSalesParams, PointOfSaleService } from 'app/back-office/shared/services/back-office/pointOfSale.service';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-pos-filter',
    templateUrl: './pos-filter.component.html',
    styleUrls: ['./pos-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PosFilterComponent implements OnInit, OnChanges {
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;

  loaderId = UtilityFunctions.newGuid();
  searchSettings: SearchSettings = {
    placeholder: 'Search point of sale...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };
  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];

  constructor(private pointOfSaleService: PointOfSaleService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.searchValue = search;
    if (search === '') this.dataToView = [new FilterItem({ text: 'STATUS.ALL', value: null })];
    this.setDataToView(0);
  }

  setDataToView(skipCount: number) {
    const filters: GetPointOfSalesParams = {
      skipCount,
      maxResultCount: 20,
      includeLocation: true,
      search: this.searchValue,
    };

    this.pointOfSaleService.getPointOfSales(this.loaderId, filters).subscribe(res => {
      this.dataToView = res.items.map(el => FilterMapper.PosFilter(el));
      this.totalCount = res.totalCount + 1;
    });
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }

}
